import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentTopBar } from 'components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
const { useBreakpoint } = Grid;

export const AssignTopBar = () => {
  useState<any>();
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const navigate = useNavigate();

  return (
    <>
      <ContentTopBar
        title={t('assignedClient.heading.assignedList')}
        renderButtons={
          <>
            <Button
              icon={!screens.xs ? <PlusOutlined /> : undefined}
              onClick={() => navigate(ROUTES.CLIENTS_ADD)} // Corrected onClick handler
              style={{ backgroundColor: '#223666', color: 'white' }}
            >
              {t('assignedClient.button.addClient')}
            </Button>
          </>
        }
      />
    </>
  );
};
